import { Accounting } from "../../types/api.model";
import { integrationModel } from "../../models";
import { userSelectors } from "./userSelectors";
import { ff } from "./ffSelectors";
const integrations = s => s.integrations.data || s.integrationsSummary.data;
const qboIntegration = s => integrationModel.qboIntegration(integrations(s));
const xeroIntegration = s => integrationModel.xeroIntegration(integrations(s));
const accountingIntegration = (s, accounting) => {
  switch (accounting) {
    case Accounting.QBO:
      return qboIntegration(s) || null;
    case Accounting.Xero:
      return xeroIntegration(s) || null;
  }
};
const isLinkedToQbo = s => {
  const qbo = qboIntegration(s);
  return !!qbo && qbo.isLinked();
};
const isLinkedToXero = s => {
  const xero = xeroIntegration(s);
  return !!xero && xero.isLinked();
};
const isLinkedToAccounting = (s, accounting) => {
  switch (accounting) {
    case Accounting.QBO:
      return isLinkedToQbo(s);
    case Accounting.Xero:
      return isLinkedToXero(s);
  }
};
const qboItems = s => s.qboItems.data;
const xeroItems = s => s.xeroItems.data;
const accountingItems = (s, accounting) => {
  switch (accounting) {
    case Accounting.QBO:
      return s.qboItems;
    case Accounting.Xero:
      return s.xeroItems;
  }
};
const accountingCustomers = (s, accounting) => {
  switch (accounting) {
    case Accounting.QBO:
      return s.qboCustomers;
    case Accounting.Xero:
      return s.xeroCustomers;
  }
};
const showQboIntegration = s => {
  return isLinkedToQbo(s) && userSelectors.isVendor(s);
};
const showXeroIntegration = s => isLinkedToXero(s) && userSelectors.isVendor(s);
const allowToCustomizeQboClasses = s => {
  const qbo = qboIntegration(s);
  return !!qbo && qbo.isLinked() && qbo.classTrackingAgreementOverride();
};
const allowTimeActivities = s => {
  const qbo = qboIntegration(s);
  return !!qbo && qbo.displayBillableTimeActivities() && qbo.isLinked();
};
const isPendingAccountingIntegrationSetup = accounting => s => {
  var _accountingIntegratio;
  return ((_accountingIntegratio = accountingIntegration(s, accounting)) === null || _accountingIntegratio === void 0 ? void 0 : _accountingIntegratio.isPendingAccountingIntegrationSetup()) || false;
};
const showInvoiceQboSection = s => !!(showQboIntegration(s) && !isPendingAccountingIntegrationSetup(Accounting.QBO)(s));
const showInvoiceXeroSection = s => !!ff.featureFlagsData(s).XERO_INTEGRATION && !!(showXeroIntegration(s) && !isPendingAccountingIntegrationSetup(Accounting.Xero)(s));
const financialCentsIntegration = s => integrationModel.financialCentsIntegration(integrations(s));
const karbonIntegration = s => integrationModel.karbonIntegration(integrations(s));
const isLinkedToFinancialCents = s => {
  const financialCents = financialCentsIntegration(s);
  return !!financialCents && integrationModel.isLinked(financialCents);
};
const isLinkedToKarbon = s => {
  const karbon = integrationModel.karbonIntegration(integrations(s));
  return !!karbon && integrationModel.isLinked(karbon);
};
const isLinkedToClientHub = s => {
  const clientHub = integrationModel.clientHubIntegration(integrations(s));
  return !!clientHub && integrationModel.isLinked(clientHub);
};
const isLinkedToKeeper = s => {
  const keeper = integrationModel.keeperIntegration(integrations(s));
  return !!keeper && integrationModel.isLinked(keeper);
};
const showFinancialCentsIntegration = s => isLinkedToFinancialCents(s) && userSelectors.isVendor(s);
const showKeeperIntegration = s => isLinkedToKeeper(s) && userSelectors.isVendor(s);
const financialCentsItems = s => s.financialCents.items.data;
const financialCentsUsers = s => s.financialCents.users.data;
const showKarbonIntegration = s => isLinkedToKarbon(s) && userSelectors.isVendor(s);
const showClientHubIntegration = s => isLinkedToClientHub(s) && userSelectors.isVendor(s);
const karbonItems = s => s.karbon.items.data;
const clientHubItems = s => s.clientHub.items.data;
const keeperItems = s => s.keeper.items.data;
const karbonUsers = s => s.karbon.users.data;
const keeperUsers = s => s.keeper.users.data;
const accounting = accounting => {
  switch (accounting) {
    case Accounting.QBO:
      return {
        items: s => s.qboItems,
        customers: s => s.qboCustomers,
        integration: qboIntegration,
        showIntegration: showQboIntegration,
        isLinked: isLinkedToQbo
      };
    case Accounting.Xero:
      return {
        items: s => s.xeroItems,
        customers: s => s.xeroCustomers,
        integration: xeroIntegration,
        showIntegration: showXeroIntegration,
        isLinked: isLinkedToXero
      };
  }
};
export const integrationSelectors = {
  accounting,
  integrations,
  qboIntegration,
  xeroIntegration,
  isLinkedToQbo,
  isLinkedToXero,
  qboItems,
  xeroItems,
  showQboIntegration,
  showXeroIntegration,
  isPendingAccountingIntegrationSetup,
  showInvoiceQboSection,
  showInvoiceXeroSection,
  allowToCustomizeQboClasses,
  allowTimeActivities,
  financialCentsIntegration,
  financialCentsItems,
  financialCentsUsers,
  showFinancialCentsIntegration,
  showKeeperIntegration,
  karbonItems,
  karbonUsers,
  keeperUsers,
  showKarbonIntegration,
  karbonIntegration,
  showClientHubIntegration,
  clientHubItems,
  keeperItems,
  isLinkedToAccounting,
  accountingItems,
  accountingCustomers,
  accountingIntegration
};